/* Copyright 2023 (Unpublished) Verto Inc. */

import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';
import { CurrentUserService } from './services/root-services/current-user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private _oauthService: OAuthService,
    private _messageService: MessageService,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit(): void {
    this._setUpDarkModeToggle();
  }

  ngAfterViewInit(): void {
    this._setUpOAuth();
  }

  private _setUpOAuth() {
    if (environment.oauth === undefined) {
      this._messageService.add({
        severity: 'warn',
        summary: 'OAuth not configured',
        detail: 'OAuth not configured for this instance of automate.',
      });
      return;
    }

    this._oauthService.configure(environment.oauth);
  }

  private _setUpDarkModeToggle() {
    (window as any).northVertoIsBestVerto = (darkMode?: true) => {
      const body = document.querySelector('body');
      if (!body) {
        return;
      }

      if (darkMode !== undefined) {
        body.classList.add(darkMode ? 'dark' : 'light');
        return;
      }

      const dark = body.classList.toggle('dark');
      localStorage.setItem('darkMode', dark.toString());
    };

    const darkMode = localStorage.getItem('darkMode') === 'true';
    (window as any).northVertoIsBestVerto(darkMode);
  }
}
